import React from 'react'
import { Container, MainHealthProcedureDetailsContainer } from './styles'
import { ModalHeader } from '../ModalComponents/ModalHeader'
import { IHealthProcedures } from '~/interfaces'
import { HealthProcedureDetails } from '~/components/healthProcedures/healthProcedureDetails'

interface VaccineDetailsProps {
  healthProcedure: IHealthProcedures
  showModal: boolean
  setShowModal: (newStateOfShowModal: boolean) => void
}

export const VaccineDetails = ({ showModal, setShowModal, healthProcedure }: VaccineDetailsProps): JSX.Element => {
  return (
    <HealthProcedureDetails showModal={showModal} setShowModal={setShowModal} viewType="SideModal">
      <MainHealthProcedureDetailsContainer>
        <Container>
          <ModalHeader title={healthProcedure.description} datetime={healthProcedure.startDate} />
        </Container>
      </MainHealthProcedureDetailsContainer>
    </HealthProcedureDetails>
  )
}
